import React from "react";
import { Button, Container, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useTabNavigate } from "../hooks/useTabNavigate";

const NotFound = () => {
  const { t } = useTranslation();
  const tabNav = useTabNavigate();

  return (
    <Container size={480} py={80}>
      <Stack align="center" spacing="md">
        <Title
          order={1}
          align="center"
          sx={(theme) => ({
            fontFamily: `Greycliff CF, ${theme.fontFamily}`,
            fontWeight: 900,
          })}
        >
          404
        </Title>
        <Title order={3} align="center">
          {t("Page not found")}
        </Title>
        <Text align="center" color="dimmed">
          {t("This address does not match a page.")}
        </Text>
        <Button
          mt="sm"
          onClick={() => tabNav.open({ pathname: "/home", label: "Home" })}
        >
          {t("Back to Home")}
        </Button>
      </Stack>
    </Container>
  );
};

export default NotFound;
